import { FC, JSX } from "react";
import { View } from "react-native";
import clsx from "clsx";

interface IDividerProps {
  className?: string;
}

const Divider: FC<IDividerProps> = ({className}): JSX.Element => {
  return <View className={clsx("my-6 border-b border-gray-light", className)} />;
};

export default Divider;
